import { Pipe, PipeTransform, inject } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { billingScope } from '../../consts';
import { PermissionService } from '../../services/permission.service';

@Pipe({
  name: 'billingScope',
  standalone: true,
})
export class BillingScopePipe implements PipeTransform {
  private permissionService = inject(PermissionService);

  transform(scope: billingScope, gallery?: GalleryDto): boolean {
    if (!scope) return true;
    return this.permissionService.canDisplayElement(scope, gallery);
  }
}
